import React, {Component} from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import {
  PROGRAMS_TABLE,
  REFERRALOUTCOME_TABLE,
  BOPINSTITUTION_TABLE,
  DRUGAFTERCAREPROGRAMS_TABLE,
  GANGAFFILIATIONS_TABLE,
  REFERRALSOURCE_TABLE,
                                                            // BHTsINSURANCEPROVIDERS_TABLE,
} from 'actions/action-constants';
import EditViewPostDischarge from './edit-view-postdischarge';
class PostDischargeViewRoot extends Component {
  componentDidMount() {
    this.props.getArchivedPostDischarge(this.props.match.params.id);
    var paramsP = { 'tablename': PROGRAMS_TABLE }
      this.props.getPrograms(paramsP);
    var paramsRO = { 'tablename': REFERRALOUTCOME_TABLE }
      this.props.getReferralOutcomes(paramsRO);
    var paramsRS = { 'tablename': REFERRALSOURCE_TABLE }
      this.props.getReferralSources(paramsRS);    
                                                          // var paramsBHTs = { 'tablename': BHTsINSURANCEPROVIDERS_TABLE }
                                                          //   this.props.getBHTsInsuranceProviders(paramsBHTs);
    var paramsBOPI = { 'tablename': BOPINSTITUTION_TABLE }
      this.props.getBOPInstitutions(paramsBOPI);
    var paramsDAP = { 'tablename': DRUGAFTERCAREPROGRAMS_TABLE }
      this.props.getDrugAftercarePrograms(paramsDAP);
    var paramsGA = { 'tablename': GANGAFFILIATIONS_TABLE }
      this.props.getGangAffiliations(paramsGA);
  }
  render() {
    /*** redirect and send to postdischarges list screen if id doesnt exist */
    if (this.props.errorInvalidEntry) {
      return <Redirect to='/postdischarges'/>;
    }
    return (
      <div>
        <EditViewPostDischarge
          {...this.props}
          postdischargeMode={3}
        />
      </div>
    );
  }
}
export default withRouter(PostDischargeViewRoot);